<template>
    <md-card-content>
        <div class="md-layout">
            <div class="md-layout-item md-size-100">
                <span class="font-bold">Responsable :</span>
                <contacts-list :contacts="contactsList('Responsable')"></contacts-list>
            </div>
        </div>
        <div class="md-layout mt-4">
            <div class="md-layout-item md-size-100">
                <span class="font-bold">Donneur d'ordre :</span>
                <contacts-list :contacts="contactsList('Donneur d\'ordre')"></contacts-list>
            </div>
        </div>
        <div class="md-layout mt-4">
            <div class="md-layout-item md-size-100">
                <span class="font-bold">Contact RDV :</span>
                <contacts-list :contacts="contactsList('Contact RDV')"></contacts-list>
            </div>
        </div>
        <div class="md-layout mt-4">
            <div class="md-layout-item md-size-100">
                <span class="font-bold">Contact Rapport :</span>
                <contacts-list :contacts="contactsList('Contact Rapport')" v-if="site.is_report_direct"></contacts-list>
                <p class="mb-0 leading-5" v-else>Pour afficher la liste des contacts rapport, modifier le site et activer l'option correspondante.</p>
            </div>
        </div>
        <div class="md-layout mt-4">
            <div class="md-layout-item md-size-100">
                <span class="font-bold">Autres :</span>
                <contacts-list :contacts="contactsList('Autres')"></contacts-list>
            </div>
        </div>
    </md-card-content>
</template>

<script>
import ContactsList from "@/pages/Sites/Contacts/components/ContactsList";
export default {
    name: "Contacts",
    components: {
        ContactsList
    },
    props: {
        site: Object
    },
    methods: {
        contactsList(type) {
            return this.site.contacts?.filter(contact => { return contact.pivot.type === type }) ?? []
        },
    }
}
</script>

<style scoped lang="scss">
::v-deep {
    .md-icon-button {
        margin: 0;
        padding: 5px;
        height: 27px;
        min-width: 35px;
        width: auto;
        line-height: 27px;
        .md-icon {
            font-size: 0.875rem !important;
            min-width: 0.875rem !important;
            height: 0.875rem !important;
        }
    }

    .contacts.md-list {
        padding-bottom: 0;
        .md-list-item {
            margin-left: 0;

            &:last-child {
                margin-bottom: 0;
            }
            .md-list-item-container {
                .md-list-item-content {
                    padding: 0;
                    min-height: 15px;
                    .md-list-item-text {
                        position: relative;
                        font-size: .75rem;
                    }
                    .md-button {
                        width: auto;
                        .md-ripple {
                            padding: 0 8px;
                        }
                    }
                    .md-icon {
                        font-size: 0.875rem !important;
                        min-width: 0.875rem !important;
                        height: 0.875rem !important;
                    }
                }
            }
        }
    }
}
</style>
